// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"71b9b269","239":"ad40150f","455":"706c2731","533":"2599c931","832":"adad26b0","977":"33d6e64c"}[chunkId] + ".chunk.js";
};